import type { ComponentType } from 'react';
import {
  IconBriefcase, IconHeartbeat, IconUsersGroup, IconCoin, IconBulbFilled,
  IconClock, IconBrain, IconHeartHandshake, IconTrendingUp, IconShield,
  IconBookmark,
} from '@tabler/icons-react';

export const TOPIC_ICONS: Record<string, ComponentType<{ size?: number | string }>> = {
  bus:  IconBriefcase,
  hlt:  IconHeartbeat,
  ldr:  IconUsersGroup,
  mon:  IconCoin,
  phi:  IconBulbFilled,
  prod: IconClock,
  psy:  IconBrain,
  rel:  IconHeartHandshake,
  slf:  IconTrendingUp,
  sto:  IconShield,
};

export const FALLBACK_TOPIC_ICON: ComponentType<{ size?: number | string }> = IconBookmark;
